import { cloneDeep } from 'lodash';
import { v4 as uuid } from 'uuid';

import { traverseItem } from 'hb-builder/utils/item';
import { type DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import { type ItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes';

export const createNewItem = <T extends ItemAttributes = ItemAttributes>(
  item:
    | DocumentItem<T>
    | Omit<DocumentItem<T>, 'id'>
    | Partial<DocumentItem<T>>,
  { isDuplicate }: { isDuplicate?: boolean } = { isDuplicate: false },
): DocumentItem<T> =>
  traverseItem(cloneDeep(item as DocumentItem<T>), (item) => {
    if (!item.id || isDuplicate) {
      item.id = uuid();
    }
  });
